import React, { useState, useEffect } from 'react';
import MainPlatform from './MainPlatform';
import WerepresenttalentPage from './WerepresenttalentPage';
import AccessCodeScreen from './AccessCodeScreen';
import PublicLanguageDock from './components/PublicLanguageDock';
import { ROUTES, navigateTo } from './domainConfig';
import { useTranslation } from './i18n';

const COMPANY_API = process.env.REACT_APP_COMPANY_API || 'http://127.0.0.1:8001';
const BASE_TITLE = process.env.REACT_APP_SEO_TITLE || 'Werepresenttalent - Talent dat kiest, past en blijft.';

export default function AppBedrijven() {
  const [path, setPath] = useState(window.location.pathname);
  const [accessGranted, setAccessGranted] = useState(
    sessionStorage.getItem('access_company') === 'true'
  );
  const { t, language } = useTranslation();

  const normalizePath = (target) => {
    try {
      return new URL(target, window.location.origin).pathname;
    } catch (_) {
      return String(target || '/').split('?')[0].split('#')[0] || '/';
    }
  };

  useEffect(() => {
    const onPopState = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  // Houd de browser-tab-titel synchroon met de huidige route.
  useEffect(() => {
    if (path.startsWith(ROUTES.bedrijvenPortaal)) {
      document.title = t('route_titles.business');
    } else {
      document.title = t('route_titles.bedrijven') || BASE_TITLE;
    }
  }, [path, t, language]);

  const navigate = (newPath) => {
    window.history.pushState({}, "", newPath);
    setPath(normalizePath(newPath));
  };

  const grantAccess = () => {
    sessionStorage.setItem('access_company', 'true');
    setAccessGranted(true);
  };

  const handleNavigate = (targetPath) => {
    navigateTo(targetPath, navigate);
  };

  // Bedrijven portaal
  if (path.startsWith(ROUTES.bedrijvenPortaal)) {
    if (!accessGranted) {
      return (
        <AccessCodeScreen 
          userType="company"
          onSuccess={grantAccess}
          onBack={() => navigate(ROUTES.bedrijvenLanding)}
        />
      );
    }
    return (
      <MainPlatform 
        userType="company" 
        apiBase={COMPANY_API} 
        onLogout={() => navigate('/')}
        onBackToHome={() => navigate('/')} 
      />
    );
  }

  // werepresenttalent landing (root)
  return (
    <>
      <PublicLanguageDock />
      <WerepresenttalentPage onNavigate={handleNavigate} />
    </>
  );
}
